/** 我的收藏气泡 — 拖拽位置 localStorage key */
export const FAV_OFFSET_STORAGE_KEY = 'fav_offset_y'

/** 默认分页大小 */
export const DEFAULT_PAGE_SIZE = 20

/** 网易云音乐 OAuth 配置（Search 页绑定流程使用） */
export const NETEASE_OAUTH = {
  clientId: 'a30102000000000098b283d2f55fe55c',
  clientType: 'web',
  authorizeUrl: 'https://music.163.com/st/platform/oauth/authorize',
  callbackOrigin: 'https://song-prod.xidongai.com',
}
